export default "__VITE_ASSET__tMWeNqsA__"